import { AfterViewInit, Component,  computed,  inject,  model, signal } from '@angular/core';
import { IonIcon, NavController } from "@ionic/angular/standalone";
import { addIcons } from 'ionicons';
import { close } from 'ionicons/icons';
import { ButtonComponent } from '../../primitives/button/button.component';
import { toObservable } from '@angular/core/rxjs-interop';
import { PreferencesService } from 'src/app/services/preferences.service';
import { StateService } from 'src/app/services/state.service';
import { AmplitudeService } from 'src/app/services/amplitude.service';
import { NativeService } from 'src/app/services/native.service';

@Component({
    selector: 'app-on-startup-modal',
    templateUrl: './on-startup-modal.component.html',
    styleUrls: ['./on-startup-modal.component.scss'],
    imports: [IonIcon, ButtonComponent]
})
export class OnStartupModalComponent implements AfterViewInit {
  private $state = inject(StateService);
  private $amplitude = inject(AmplitudeService);
  private $preferences = inject(PreferencesService);
  private $native = inject(NativeService);
  private navCtrl = inject(NavController);

  public visible = model<boolean>(false);

  public rendered = signal<boolean>(false);
  public classesApplied = signal<boolean>(false);

  public isWeb = this.$native.isWeb;
  public mode = computed<"newUser" | "existingUser" | "lazyUser">(() => {
    const user = this.$state.bUser.getValue();
    if (!user) return "newUser"; // New users
    else return "existingUser"; // Existing User uploaded scripts before
    // TODO: Add this?
    // return "lazyUser"; // User hasn’t added a script within a set period after onboarding
  });

  public origin = signal<string>("PromoPrompt");
  public content = computed<string>(() => this.mode() == "newUser" ? "MyScriptsNewUser" : "MyScriptsExistingUser");

  public title = computed<string>(() => ({
    newUser: "All your scripts in one safe place",
    existingUser: "All your scripts in one safe place",
    lazyUser: "Start using My Scripts today!",
  }[this.mode()]));

  public description = computed<string>(() => ({
    newUser: "Our app now features My Scripts.  Staying on top of your scripts is now easier than ever…",
    existingUser: "Our app now features My Scripts.  Staying on top of your scripts is now easier than ever…",
    lazyUser: "Add your first eScript to securely store, manage, and order with ease.",
  }[this.mode()]));

  constructor() {
    addIcons({ close });
    toObservable(this.visible).subscribe(vis => {
      if (vis == this.rendered()) return;
      if (vis) {
        this.open();
      } else {
        this.close();
      }
    });
  }

  ngAfterViewInit() {
    this.determineIfShouldOpen();
  }

  async determineIfShouldOpen() {
    const hasntBeenViewed = await this.$preferences.checkMyScriptsStartupModal();
    if (hasntBeenViewed) {
      setTimeout(() => this.visible.set(true), 1000);
    }
  }

  open() {
    this.rendered.set(true);
    setTimeout(() => this.classesApplied.set(true), 20);
    this.$amplitude.track('PROMO_PROMPT_VIEWED', {
      origin: this.origin(),
      content: this.content(),
      UI: "Modal",
    });
  }

  close() {
    this.classesApplied.set(false);
    setTimeout(() => this.rendered.set(false), 200);
    this.$amplitude.track('PROMO_PROMPT_CLOSED', {
      origin: this.origin(),
      content: this.content(),
      UI: "crossTopRight",
    });
  }

  addScript() {
    this.close();
    this.$amplitude.track('ADD_SCRIPT_CTA', {
      origin: this.origin(),
      content: this.content(),
      UI: "PrimaryCTA_Button",
    });
    this.navCtrl.navigateForward(['/add-script']);
  }

  learnMore() {
    this.$amplitude.track('LEARN_MORE_CLICKED', {
      origin: this.origin(),
      content: this.content(),
      UI: "SecondaryCTA_TextLink",
    });
  }
}
